<div class="change-task-author" [formGroup]="authorFormGroup">
    <!-- Author Type -->
    <div class="example-form">
        <mat-form-field class="example-full-width d-block" floatLabel="always"
            [ngClass]="{ 'form-validator-message-text' : authorFormGroup.get('Tipo').touched && authorFormGroup.get('Tipo').invalid }">
            <mat-label>Autor</mat-label>
            <mat-select formControlName="Tipo" (selectionChange)="onAuthorTypeChange($event)">
                <mat-option *ngFor="let option of authorTypesList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="authorFormGroup.get('Tipo')?.touched&& authorFormGroup.get('Tipo')?.invalid">
            <span *ngIf="authorFormGroup.get('Tipo').errors.required" class="validation-span">Obligatorio</span>
        </mat-error>
    </div>

    <!-- Users -->
    <div class="example-form" *ngIf="dropDownActivate.user">
        <mat-form-field class="example-full-width d-block" floatLabel="always"
            [ngClass]="{ 'form-validator-message-text' : authorFormGroup.get('Usuario').touched && authorFormGroup.get('Usuario').invalid }">
            <mat-label>Usuario</mat-label>
            <mat-select formControlName="Usuario" (selectionChange)="onUserChange($event)">
                <mat-option *ngFor="let option of usersList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="authorFormGroup.get('Usuario')?.touched && authorFormGroup.get('Usuario').invalid">
            <span *ngIf="authorFormGroup.get('Usuario').errors.required" class="validation-span">Obligatorio</span>
        </mat-error>
    </div>

    <!-- Doctors -->
    <div class="example-form" *ngIf="dropDownActivate.doctor">
        <mat-form-field class="example-full-width  d-block" floatLabel="always"
            [ngClass]="{ 'form-validator-message-text' : authorFormGroup.get('Medico').touched && authorFormGroup.get('Medico').invalid }">
            <mat-label>Medico</mat-label>
            <mat-select formControlName="Medico" (selectionChange)="onDoctorChange($event)">
                <mat-option *ngFor="let option of doctorsList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-error *ngIf="authorFormGroup.get('Medico')?.touched && authorFormGroup.get('Medico').invalid">
            <span *ngIf="authorFormGroup.get('Medico').errors.required" class="validation-span">Obligatorio</span>
        </mat-error>
    </div>

    <!-- Coordinators -->
    <div class="example-form" *ngIf="dropDownActivate.coordinador">
        <mat-form-field class="example-full-width  d-block" floatLabel="always"
            [ngClass]="{ 'form-validator-message-text' : authorFormGroup.get('Coordinator').touched && authorFormGroup.get('Coordinator').invalid }">
            <mat-label>Coordinador</mat-label>
            <mat-select formControlName="Coordinator" (selectionChange)="onCoordinatorChange($event)">
                <mat-option *ngFor="let option of coordinatorsList" [value]="option.value">
                    {{option.viewValue}}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-error *ngIf="authorFormGroup.get('Coordinator')?.touched&& authorFormGroup.get('Coordinator').invalid">
            <span *ngIf="authorFormGroup.get('Coordinator').errors.required" class="validation-span">Obligatorio</span>
        </mat-error>
    </div>

    <input type="hidden" formControlName="Nombre">
    <input type="hidden" formControlName="MedicoId">

</div>